import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from 'src/styles/media';

const Hotspot = ({ children, active, x, y, onMouseEnter, onMouseLeave }) => {
  const handleMouseEnter = () => {
    onMouseEnter();
  };

  const handleMouseLeave = () => {
    onMouseLeave();
  };

  return (
    <Root
      style={{
        left: `${x}%`,
        top: `${y}%`,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Caption active={active}>{children}</Caption>
    </Root>
  );
};

Hotspot.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  active: PropTypes.bool,
};

Hotspot.defaultProps = {
  x: 0,
  y: 0,
  onMouseEnter: f => f,
  onMouseLeave: f => f,
  active: false,
};

const Root = styled.div`
  width: 47px;
  height: 47px;
  position: absolute;
  border: 2px solid rgba(255, 255, 255, 0.44);
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.44);
  transform: translate(-50%, -50%);
  color: #fff;
  background-image: url(${require('src/assets/images/icons/info.svg')});
  background-position: 50% 50%;
  background-repeat: no-repeat;
  cursor: pointer;
  @media (max-width: ${media.md}) {
    display: none;
  }
`;

const Caption = styled.div`
  width: 175px;
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  font-size: 11px;
  letter-spacing: 1px;
  pointer-events: none;
  opacity: ${props => props.active ? '1' : '0'};
  transform: ${props => props.active ? 'translateY(0)' : 'translateY(5px)'};
  transition: all 0.25s;
`;

export default Hotspot;



// WEBPACK FOOTER //
// ./src/pages/Amenities/elements/Hotspot.js